// tempCodec.js

const TEMP_MINIMUM = -40.0; // Minimum temperature
const TEMP_MAXIMUM = 120.0; // Maximum temperature

/**
 * Encode a float temperature [-40.00, 120.00] to uint16 (2 decimal places)
 * @param {number} temp
 * @returns {number} Encoded uint16 value
 */
export const temperatureEncode = (temp) => {
  // Clamp to range
  if (temp < TEMP_MINIMUM) temp = TEMP_MINIMUM;
  if (temp > TEMP_MAXIMUM) temp = TEMP_MAXIMUM;
  // Offset and scale
  return Math.round((temp - TEMP_MINIMUM) * 100);
};

/**
 * Decode uint16 to float temperature [-40.00, 120.00] (2 decimal places)
 * @param {number} encoded
 * @returns {number} Decoded temperature
 */
export const temperatureDecode = (encoded) => {
  return encoded / 100 + TEMP_MINIMUM;
};
